import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { IdType, RoundHistory } from "../type";
import ApiService, { Response } from "../services/api-services";
import Utils from "../utils";

type Props = {
  gameCode: string;
  type: IdType;
  id: string;
};

export const useFetchRoundHistory = ({ gameCode, type, id }: Props) => {
  const [roundHistory, setRoundHistory] = useState<RoundHistory>();
  useEffect(() => {
    if (!type || type === IdType.Unknown || !id) return;
    switch (type?.toLowerCase()) {
      case IdType.Rounds:
      case IdType.Plays:
        ApiService.getRoundHistoryByRoundId(gameCode, id).then(afterAPI);
        break;
      case IdType.Spins:
      case IdType.BetBatches:
        ApiService.getRoundHistoryBySpinId(gameCode, id).then(afterAPI);
        break;
    }
  }, [gameCode, type, id]);

  function afterAPI(res: Response<RoundHistory>) {
    if (res.ok && res.data) {
      document.title = res.data.roundReferenceNumber;
      Utils.setCurrencySymbol(res.data.currencySymbol);
      setRoundHistory(res.data);
    } else {
      setRoundHistory(undefined);
    }
  }

  return roundHistory;
};
